import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PIPES } from './pipes';
import { DIRECTIVES } from './directives';
import { COMPONENTS } from './components';

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [...PIPES, ...COMPONENTS, ...DIRECTIVES],
  exports: [...PIPES, ...COMPONENTS, ...DIRECTIVES],
})
export class UtilsModule {}
